import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AcademicFeeDto } from '../models/academicfeedto';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { AppConfigService } from './core/appConfig.service';
@Injectable({
    providedIn: 'root'
})
export class AcademicTaxesService {

    constructor(private http: HttpClient, private configService:AppConfigService) { }

    getListAcademicTaxes(pageRequest: PaginationFeaturesDto, codeRateModel: string | undefined | null): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', pageRequest.orderField)
            .set('order', pageRequest.order);

        let url = `${this.configService.apiUrl}/configuration/own-academic-fee/getAll?${params}`;
        if (codeRateModel != null) {
            url += `&codeRateModel=${codeRateModel}`;
        } else {
            url += `&codeRateModel=`;
        }

        return this.http.get<any>(url).pipe(map(response => { return response; }));
    }

    getAcademicFeeById(idOwnAcademicFee: number): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-academic-fee/filter/${idOwnAcademicFee}`;
        return this.http.get<any>(url).pipe(map(response => { return new AcademicFeeDto(response); }));
    }

    insertAcademicFee(academicFeeDto: AcademicFeeDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-academic-fee/insert`;
        return this.http.post<any>(url, academicFeeDto).pipe(map(response => { return response; }));
    }

    updateAcademicFee(actionBoolean: boolean, academicFeeDto: AcademicFeeDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/own-academic-fee/update/${actionBoolean}`;
        return this.http.put<any>(url, academicFeeDto).pipe(map(response => { return response; }));
    }
}